import Navigation from "./Components/NavigationComponent/Navigation";
import TopNavigation from "./Components/NavigationComponent/TopNavigation";

function AboutPage() {
    return <>
        <Navigation />
        <TopNavigation />
        <div className="page-container" style={{ padding:"15px" }}>
            <h1 class="display-5">About</h1>
            <p>
                The management server validates the devices to ensure it's a genuine device from the respective device provider. This can be achieved using the device info and the certificates.
                Keys are safely stored in the HSM and these keys are used to issue the device certificate upon registration of the device with the Management Server.
            </p>
        </div>
    </>
}

export default AboutPage;